var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCursor24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32213_212279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9337 22.5217L21.0745 17.2609L11.9337 12L2.79297 17.2609L11.9337 22.5217Z",
    fill: "url(#paint0_linear_32213_212279)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0744 17.2611V6.73939L11.9336 1.47852V12.0003L21.0744 17.2611Z",
    fill: "url(#paint1_linear_32213_212279)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9337 1.47852L2.79297 6.73939V17.2611L11.9337 12.0003V1.47852Z",
    fill: "url(#paint2_linear_32213_212279)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0744 6.73926L11.9336 22.5219V12.0001L21.0744 6.73926Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0745 6.73926L11.9337 12.0001L2.79297 6.73926H21.0745Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32213_212279",
    x1: 11.9337,
    y1: 12,
    x2: 11.9337,
    y2: 22.5217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658,
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32213_212279",
    x1: 21.0744,
    y1: 6.77183,
    x2: 11.9336,
    y2: 12.1318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.182,
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_32213_212279",
    x1: 11.9337,
    y1: 1.47852,
    x2: 2.79297,
    y2: 17.2611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32213_212279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.1304,
    height: 22,
    fill: "white",
    transform: "translate(2.43457 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursor24);
export default __webpack_public_path__ + "static/media/Cursor24.eb5772a2bf1f7eee009eb29883d92078.svg";
export { ForwardRef as ReactComponent };